exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-configure-signal-settings-component[data-v-0472f697] {\n  position: relative;\n}\n.automation-configure-signal-settings-component .ant-select[data-v-0472f697] {\n  width: 100% !important;\n  display: block !important;\n}", ""]);

// exports
